export { TextDiffComponent } from './text-diff.component';
